import {
    MASTER_DATA_ERROR_ACTION_TYPE,
    MASTER_DATA_FETCH_START_ACTION_TYPE,
    MASTER_DATA_FETCH_SUCCESS_ACTION_TYPE,
    MasterDataAction
} from 'actions/masterData/MasterDataActionsTypes';
import { convertMasterData } from 'actions/masterData/MasterDataConverter';
import { MasterDataDto } from 'actions/masterData/MasterDataDtos';
import { MasterDataError } from 'actions/masterData/MasterDataError';
import { ApiClient } from 'api/ApiClient';
import { AxiosResponse } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { MasterData } from 'types/MasterData';

const masterDataUrl = '/master_data';

const errorHandler = (error: unknown): MasterDataAction => {
    console.error(error);

    return {
        type: MASTER_DATA_ERROR_ACTION_TYPE
    };
};

export const fetchMasterDataThunk = (
    marketplaceId: number
): ThunkAction<Promise<MasterData>, RootState, null, RootAction> => {
    return async dispatch => {
        dispatch(fetchStart());

        try {
            const { data }: AxiosResponse<MasterDataDto> = await ApiClient.get(masterDataUrl, {
                params: {
                    marketplace_id: marketplaceId
                }
            });

            const masterData = convertMasterData(data);

            dispatch(fetchSucces(masterData));

            return masterData;
        } catch (error) {
            dispatch(errorHandler(error));

            throw new MasterDataError();
        }
    };
};

const fetchStart = (): MasterDataAction => {
    return {
        type: MASTER_DATA_FETCH_START_ACTION_TYPE
    };
};

export const fetchSucces = (masterData: MasterData): MasterDataAction => {
    return {
        type: MASTER_DATA_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            masterData
        }
    };
};
